import { FormGroup, FormSelect } from '@spotify-internal/encore-web';

import withTranslation from 'lib/shared/i18n/withTranslation';

import BaseField from '../BaseField/BaseField';

class SelectField extends BaseField {
  render() {
    const { field, t, value, tPrefix, hasDefaultPlaceholder, showRawOptionLabels } = this.props;
    const placeholderText = (hasDefaultPlaceholder && t(`${tPrefix}_placeholder`)) || t('contact_form:dropdown_select');

    return (
      <FormGroup
        data-error={this.showError()}
        key={field.name}
        label={this.getLabel()}
        labelFor={field.name}
        indicator={this.getIndicator()}
      >
        <FormSelect
          id={field.name}
          value={value}
          aria-describedby={this.getAriaDescribedBy()}
          aria-required={field.required}
          aria-invalid={this.showError()}
          onChange={this.fieldChange}
          error={this.showError()}
        >
          <option disabled value="">
            {placeholderText}
          </option>
          {field.options.map(option => {
            const defaultLabel = field.labelOverride
              ? t(`${tPrefix}_${option}`)
              : t(`${tPrefix}${field.name}_${option}`);
            return (
              <option key={option} value={option}>
                {showRawOptionLabels ? option : defaultLabel}
              </option>
            );
          })}
        </FormSelect>
        {this.getHelpText()}
        {this.getError()}
      </FormGroup>
    );
  }
}

export default withTranslation()(SelectField);
